export default __webpack_public_path__ + "static/media/06AW2SEP66.2aa5433c.jpg";